import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button
} from "@mui/material"
import { Checkbox } from 'antd'

const PrepareForMapStage = ({ rowData, mainProps, setErrorMessage }) => {



  return (
    <Box>
      <Checkbox
        disabled={mainProps.loading || rowData.row.projectLevelEnum !== 6 
        || rowData.row.isPrepareForMapStage || 
        (rowData.row.projectLevelEnum === 6 && rowData.row.inspectionStatusEnum !==1) }
        checked={ rowData.row.isPrepareForMapStage}
        onChange={async () => {
            const { onPrepareForMapStage } = mainProps
            if(window.confirm("در صورت تایید واحد گاز مرحله نقشه را تخصیص میدهد")){
                await onPrepareForMapStage({gpId:rowData.row.id, prepare:!rowData.row.isPrepareForMapStage})
            }
           
        }}
      >
      </Checkbox>

    </Box>
  )
}

export default PrepareForMapStage
